import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
import { useEffect, useState } from 'react';
import {
  Card,
  CardHeader,
  Box,
  Stack,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@material-ui/core';
import moment from 'moment';
import { baseUrl, tempProvinces } from '../../../../utils/constants';
import { BaseOptionChart } from '../../../charts';
import { useConstantsContext } from '../../../../context/constants_context';

export default function MembershipRegionChart({ dataList }) {
  const { payCycles, chartData, getMonthlyReport, getDistStats } = useConstantsContext();
  const [group, setGroup] = useState(1);
  const [payCycleId, setPayCycle] = useState(Number(sessionStorage.getItem('payCycleId')));
  const chartLabels = chartData.map((i) => i.descriptions);
  const chartSeries = chartData.map((i) => i.count);
  const CHART_DATA = [
    {
      name: '#',
      type: 'column',
      data: chartSeries
    }
  ];

  useEffect(() => {
    getDistStats(payCycleId, group);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartData]);

  useEffect(() => {
    if (payCycleId && group !== '') {
      getDistStats(payCycleId, group);
    }
  }, [payCycleId, group]);

  const chartOptions = merge(BaseOptionChart(), {
    plotOptions: { bar: { columnWidth: '55%', borderRadius: 4 } },
    fill: { type: ['solid'] },
    colors: ['#0C5935'],
    dataLabels: {
      enabled: true,
      formatter(val) {
        return `${val}`;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        color: '#00000'
      }
    },
    labels: chartLabels,
    xaxis: { type: 'text' },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)} clients`;
          }
          return y;
        }
      }
    }
  });

  const changeCycle = (prov, cycle) => {
    console.log('group is ooo ', prov);
    console.log('cycle is 000 ', cycle);
    setGroup(prov);
    setPayCycle(cycle);
    getDistStats(cycle, prov);
  };

  const changeCyclePeriod = (prov) => {
    console.log('group is cycle ', prov);
    console.log('cycle is cycle ', payCycleId);
    setGroup(prov);
    getDistStats(payCycleId, prov);
  };

  return (
    <Card>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb="10" mr="10">
        {group > 0 && <CardHeader title="By District..." subheader="" />}
        {group === 0 && <CardHeader title="By Province..." subheader="" />}
        <FormControl sx={{ mr: 2 }}>
          <InputLabel id="payProvinceLbl">Province</InputLabel>
          <Select
            value={group}
            size="small"
            variant="outlined"
            style={{ width: 220 }}
            onChange={(e, key) => {
              changeCycle(e.target.value, payCycleId);
            }}
          >
            <MenuItem key="0" value="">
              Not Selected
            </MenuItem>
            {tempProvinces.slice(0, 12).map((item) => (
              <MenuItem key={item.refId} value={item.refId}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ mr: 2 }}>
          <InputLabel id="payCycleLbl">Stroke</InputLabel>
          <Select
            value={payCycleId}
            size="small"
            variant="outlined"
            style={{ width: 220 }}
            onChange={(e, key) => {
              changeCycle(group, e.target.value);
            }}
          >
            <MenuItem key="0" value="">
              Not Selected
            </MenuItem>
            {payCycles.slice(0, 12).map((item) => (
              <MenuItem key={item.payCycleId} value={item.payCycleId}>
                {moment(item.payDate).isValid() ? moment(item.payDate).format('YYYY-MM-DD') : ''}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart type="bar" series={CHART_DATA} options={chartOptions} height={364} />
      </Box>
    </Card>
  );
}
